import { checkAppmate, formatPrice } from "../../helpers";
import { WishlistIcon } from "..";
import locale from "../../../../locales/en.default.json";

// Handle standard Badging
const handleBadge = (metafields, isWLT = false) => {
  let { badge_text, has_background, badge_image } = metafields;

  if (metafields.length) {
    badge_text =
      metafields.find((field) => field.key === "badge_text")?.value ||
      badge_text ||
      null;
    has_background =
      metafields.find((field) => field.key === "has_background")?.value ||
      has_background ||
      false;
    badge_image =
      metafields.find((field) => field.key === "badge_image")?.value ||
      badge_image ||
      null;
  }

  const wltImage = document.body.dataset.wltImage;
  const badgeText = isWLT ? "Tree Donation" : badge_text;

  const badgeBackground = isWLT
    ? "badge--teal"
    : has_background
    ? "badge--pink"
    : "";

  let hasImage = badge_image;

  if (typeof hasImage === "string") {
    hasImage = JSON.parse(hasImage);
  }
  const badgeImage = (isWLT && wltImage) || (hasImage ? hasImage[0] : null);

  if (badgeText) {
    return `
      <div class="badge ${badgeBackground}">
        ${
          badgeImage
            ? `
          <img
            class="badge__image"
            src="${badgeImage.src || badgeImage}"
            height="44"
            width="${44 * (badgeImage.aspect_ratio || 2)}"
            alt="${badgeText}"
          />
          `
            : ""
        }
        <p class="badge__text">${badgeText}</p>
      </div>
    `;
  }
  return "";
};

// Handle limited-time-sale Badging
const handleLTSBadge = (limitedSale) => {
  const { icon, text } = limitedSale;
  return `
    <div class="badge">
    ${
      icon
        ? `
      <img
        class="badge__image"
        src="${icon}"
        height="44"
        width="44"
        alt="${text}"
      />
      `
        : ""
    }
      <p class="badge__text">${text}</p>
    </div>
  `;
};

// @TODO: Refactor this
const handleSampleText = (product) => {
  const hasSample = product.variants.find((variant) =>
    variant.merged_options.find((option) =>
      option.toLowerCase().includes("sample")
    )
  );

  // Leaving this in the event that the client changes their mind
  // return hasSample ? "Samples" : "";

  return "";
};

const handleSamplePrice = (product, selectedVariant) => {
  const hasSample = product.variants.find((variant) =>
    variant.merged_options.find((option) =>
      option.toLowerCase().includes("sample")
    )
  );

  return hasSample ? hasSample.price : selectedVariant.price;
};

// @TODO: Tidy this up
const renderPriceGroup = ({
  isTrade,
  selectedVariant,
  comparePrice,
  price,
  data,
  product,
  discount,
  sale_alt_text,
  saleAltStart,
  saleAltEnd,
  sale_alt_tag,
  override_discount,
  present,
}) => {
  const showSaleAltText =
    present < saleAltEnd &&
    present > saleAltStart &&
    product.tags.includes(sale_alt_tag);

  const handleizedTags = product.tags.map((tag) => tag.split(" ").join("-"));
  return `
    <div class="price-group ${isTrade ? "price-group--trade" : ""}">  
      <p class="price">
        ${isTrade ? "Trade Price: " : ""}
        ${
          window.location.search.includes("sort_by=price")
            ? handleSampleText(product)
            : ""
        }
        ${
          product.variants.length > 1 &&
          window.location.pathname !== "/pages/wishlist"
            ? "From "
            : ""
        }
        ${formatPrice(price, !data.price_divided && true, true)}
      </p>
      ${
        isTrade
          ? `<del>${formatPrice(selectedVariant.price, false)}</del>`
          : `
          <del class="price price--discounted ${
            !comparePrice || comparePrice <= price ? "hidden" : ""
          }">
            ${formatPrice(comparePrice, !data.price_divided && true)}
          </del>
        `
      }
      ${
        showSaleAltText || price < comparePrice
          ? `
            <p class="price price--saving ${
              (discount && discount < 1) ||
              (override_discount && !(discount > 0) && !showSaleAltText)
                ? "hidden"
                : ""
            }">
              ${
                override_discount && discount > 0
                  ? `${discount}% off`
                  : showSaleAltText
                  ? sale_alt_text
                  : `${discount}% off`
              }
            </p>
          `
          : ""
      }
    <p class="price price--unavailable ${
      data.product.available ? "hidden" : ""
    }">
      ${handleizedTags.includes("coming-soon") ? "Coming Soon" : "Out of Stock"}
    </p>
  </div>
  `;
};

const ProductCard = (
  data,
  variantId,
  hasBackground = false,
  inWishlist = false
) => {
  const { product } = data;
  product.description = "";
  product.content = "";

  const selectedVariant =
    product.variants?.find((variant) => variant.id == variantId) ||
    product.variants[0];

  let currency;
  document.cookie.split("; ").find((_cookie) => {
    const cookieData = _cookie.split("=");
    if (cookieData && cookieData[0] === "cart_currency") {
      currency = cookieData[1].toLowerCase();
    }
  });

  let firstImage = product.media[0]?.src || product.images_info[0]?.src;
  let secondImage =
    product.media[1]?.src ||
    (product.images_info && product.images_info[1]?.src) ||
    null;
  const isTrade = typeof trade_discount !== "undefined" ? true : false;

  const localCurrency = currency ? `_${currency}` : "";

  const price =
    parseFloat(selectedVariant[`price${localCurrency}`]) ||
    parseFloat(selectedVariant.price);
  const comparePrice =
    parseFloat(selectedVariant[`compare_at_price${localCurrency}`]) ||
    parseFloat(selectedVariant.compare_at_price);

  const discount = Math.round(100 - (price / comparePrice) * 100);

  const limitedSale = JSON.parse(document.body.dataset.limitedSale);
  const { sale_from, sale_to, sale_tag } = limitedSale;
  const saleStart = Date.parse(sale_from);
  const saleEnd = Date.parse(sale_to);
  const present = Date.now();

  const altSale = JSON.parse(document.body.dataset.limitedSaleAlt);
  const {
    sale_alt_from,
    sale_alt_to,
    sale_alt_tag,
    sale_alt_text,
    override_discount,
  } = altSale;
  const saleAltStart = Date.parse(sale_alt_from);
  const saleAltEnd = Date.parse(sale_alt_to);

  let colourIndex = -1;

  if (selectedVariant.merged_options) {
    colourIndex = selectedVariant.merged_options.findIndex(
      (option) => option.includes("color") || option.includes("colour")
    );
  } else {
    colourIndex = product.options.findIndex((option) => {
      const _option = option.toLowerCase();
      return _option === "colour" || _option === "color";
    });
  }

  if (colourIndex >= 0) {
    const _optionIndex = `option${colourIndex + 1}`;
    const colourOption = selectedVariant.merged_options
      ? selectedVariant.merged_options[colourIndex]
      : selectedVariant[_optionIndex];

    if (colourOption) {
      const colour = colourOption.includes(":")
        ? colourOption.split(":")[1]
        : colourOption;
      const media = product.images_info || product.media;

      const colourImages = media.filter((image) => {
        return image.alt && image.alt.includes(colour);
      });

      if (colourImages.length > 1) {
        firstImage = colourImages[0].src;
        secondImage = colourImages[1].src ?? null;
      }
    }
  }

  return `
  <div
      class="product-card ${hasBackground ? "product-card--light" : ""}"
      data-controller="product-card"
      data-product-card-product-value='${product.id}'
      id="${selectedVariant.id}"
    >
      <div class="product-card__top">
        <div class="product-card__wishlist" data-wishlist-target="icon" data-variant-id="${
          selectedVariant.id
        }">
          ${WishlistIcon(
            selectedVariant.id,
            product.id,
            inWishlist ? "add" : "remove"
          )}
        </div>
        <a
          data-action="collection#handleLink"
          data-collection-id-param="${selectedVariant.id}"
          href="/products/${product.handle}?variant=${selectedVariant.id}"
          class="product-card__image-wrap ${
            secondImage ? "product-card__image-wrap--double" : ""
          }"
        >
          <img
            src="${firstImage}&width=350&height=350&crop=center"
            class="product-card__main-image"
            loading="lazy"
            alt="${product.title}"
            height="350"
            width="350"
            data-product-card-target="mainImage"
          />
          <img
            src="${firstImage}&width=350&height=350&crop=center"
            loading="lazy"
            class="product-card__swatch-image product-card__swatch-image--hidden"
            alt="${product.title}"
            height="350"
            width="350"
            data-product-card-target="hoverImage"
          />
          ${
            product.media[1] || (product.images_info && product.images_info[1])
              ? `
              <img
                loading="lazy"
                src="${secondImage}&width=350&height=350&crop=center"
                alt="${product.title}"
                height="350"
                width="350"
              />
            `
              : ""
          }
        </a>
        ${
          !window.location.pathname.includes("wishlist")
            ? `
        <button
          data-quickshop-product-handle-param="${product.handle}"
          data-quickshop-product-id-param="${product.id}"
          data-quickshop-variant-param="${selectedVariant.id}"
          data-action="quickshop#openQuickshop" 
          class="product-card__quickshop-cta"
        >
          ${Shopify.theme.locale.quickshop.view || "Quick View"}
        </button>
        `
            : ""
        }
      </div>
      <div class="product-card__bottom">
        <a
            data-action="collection#handleLink"
            data-collection-id-param="${selectedVariant.id}"
            href="/products/${product.handle}?variant=${selectedVariant.id}"
            class="product-card__title"
        >
            ${product.title}
        </a>
        
        ${renderPriceGroup({
            isTrade,
            selectedVariant,
            comparePrice,
            price,
            data,
            product,
            discount,
            sale_alt_text,
            saleAltStart,
            saleAltEnd,
            sale_alt_tag,
            override_discount,
            present,
        })}

        ${
            present < saleEnd &&
            present > saleStart &&
            price < comparePrice &&
            product.tags.includes(sale_tag)
            ? handleLTSBadge(limitedSale)
            : handleBadge(
                data.product.metafields || data.product_meta,
                product.tags.includes("WLT")
                )
        }
        </div>
    </div>
  `;
};

export default ProductCard;
